import { createAction, props } from '@ngrx/store';

export interface Brand {
  id: number;
  name: string;
  division: string;
  branches?: Branch[];
  logos: Logo[];
}

export interface Branch {
  id: number;
  CpnyID: string;
  name: string;
  places: Place[];
}

export interface Place {
  name: string;
}

export interface Logo {
  id: number;
  description: string;
  isPrincipal: boolean;
  createdAt: string;
  updatedAt: string;
  image: Image;
}

export interface Image {
  id: number;
  name: string;
  full: string;
  large: string;
  medium: string;
  small: string;
  index: any;
}

export interface BrandsState {
  brands: Brand[];
  loading: boolean;
  error: string | null;
}

export const loadBrands = createAction('[Brands] Load Brands');

export const loadBrandsSuccess = createAction(
  '[Brands] Load Brands Success',
  props<{ brands: Brand[] }>()
);

export const loadBrandsFailure = createAction(
  '[Brands] Load Brands Failure',
  props<{ error: string }>()
);

export const setBrands = createAction(
  '[Brands] Set Brands',
  props<{ brands: Brand[] }>()
);

export const clearBrands = createAction('[Brands] Clear Brands');
